// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__WGDVY","size--small":"logo_size--small__K-2ws","size--medium":"logo_size--medium__+JbSl","size--large":"logo_size--large__Zoc5W"};